// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// console.log("--- Firebase Initializing ---");
// console.log("Project ID:", process.env.REACT_APP_FIREBASE_PROJECT_ID);
// // Only log the first few characters of the API Key for security
// console.log("API Key loaded:", !!process.env.REACT_APP_FIREBASE_API_KEY); 

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);

// IMPORTANT: Point to your new database name here
export const db = getFirestore(app, "acbypr-prod");
